import React from 'react'

function Number() {
  return (
    <>
        
        <section className='number'>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-12">
            <h2>1528+</h2>
            <p>SAVINGS</p>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <h2>1751+</h2>
            <p>PHOTOS</p>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <h2>1674+</h2>
            <p>ROCKETS</p>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <h2>1858+</h2>
            <p>GLOBES</p>
          </div>
        </div>
      </div>
    </section>
    
    </>  )
}

export default Number